import Hero from '../components/Hero';

const Redesign = ({ data }) => {
  if (!data) return <></>;

  return (
    <>
      {data?.map((component, position) => {
        switch (component.formatid) {
          case 368:
            return (
              <Hero
                key={position}
                data={component.data.block_reference}
                gaBlockName={'Hero Carousel'}
                topMargin={false}
                singleHero={true}
                autoplay={false}
                showHero={true}
                salePromo={false}
                heroOptions={{
                  classes: 'hero-1 mt-12 lg:mt-12'
                }}
              />
            );
          default:
            return (
              <div className="w-full bg-gray-200 h-[100px] flex items-center justify-center text-lg">
                <p>
                  Component{' '}
                  <span className="font-bold">'{component.name}'</span> needs
                  creating and adding to switch statement
                </p>
              </div>
            );
        }
      })}
    </>
  );
};

export default Redesign;
